export default __webpack_public_path__ + "static/cart-8d60c5a42692ea43e8f666e6e799d781.png";